import React from 'react';
import BannerPreview from '../modules/Banners/BannerPreview/BannerPreview';

function BannerPreviewPage(){
  return <BannerPreview/>
}

export default BannerPreviewPage;